import { makeStyles } from '@mui/styles';
const loginStyles = makeStyles(() => ({
    title: {},
    subTitle: {},
    subTitleContainer: {},
    subTitleSecondary: {},
}), { name: 'Login' });
export default loginStyles;
//# sourceMappingURL=login.styles.js.map